module.exports = __webpack_public_path__ + "img/arrow-next-level.bd580479.svg";